module.exports = __webpack_public_path__ + "img/Game_target_Z-15.a67b1be3.png";